export function formatIsoDateWithTime(isoDateString: string | null) {
    if (!isoDateString)
        return {
            reportIssuedes: '',
            reportIssueden: '',
        };

    const date = new Date(isoDateString);

    // Formato "dd-MM-yyyy HH:mm"
    const formattedDDEread =
        `${String(date.getUTCDate()).padStart(2, '0')}-${String(date.getUTCMonth() + 1).padStart(
            2,
            '0'
        )}-${date.getUTCFullYear()} ` +
        //Quitando horas y minutos
        `${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(
            2,
            '0'
        )}`;

    // Formato "yyyy-MM-dd HH:mm"
    const formattedYYYYeadr =
        `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(
            date.getUTCDate()
        ).padStart(2, '0')} ` +
        //Quitando horas y minutos
        `${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(
            2,
            '0'
        )}`;
    return {
        reportIssuedes: formattedDDEread, // "25-09-2025 14:30"
        reportIssueden: formattedYYYYeadr, // "2025-09-25 14:30"
    };
}
